"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  kistlerCorporate: {
    "id": "Kistler Corporate",
    "defaultMessage": "Kistler Corporate"
  },
  kistlerHomePage: {
    "id": "Kistler Home Page",
    "defaultMessage": "Kistler Home Page"
  },
  customerServicesAndSupport: {
    "id": "Customer Services and Support",
    "defaultMessage": "Customer Services and Support"
  },
  kistlerContactInformation: {
    "id": "Kistler Contact Information",
    "defaultMessage": "Kistler Contact Information"
  },
  termsAndConditionsForSalesAndService: {
    "id": "Terms and Conditions for Sales and Service",
    "defaultMessage": "Terms and Conditions for Sales and Service"
  },
  termsAndConditionsOfPurchase: {
    "id": "Terms and Conditions of Purchase",
    "defaultMessage": "Terms and Conditions of Purchase"
  },
  about: {
    "id": "About",
    "defaultMessage": "About"
  },
  copyrightKistlerHoldingAGAllRightsReserved: {
    "id": "Copyright {Year}: Kistler Holding AG - All rights reserved",
    "defaultMessage": "Copyright {Year}: Kistler Holding AG - All rights reserved"
  },
  kistlerandKistlerlogotrademarks: {
    "id": "Kistler and the Kistler logo are trademarks of the Kistler Holding AG and are registered in various countries.",
    "defaultMessage": "Kistler and the Kistler logo are trademarks of the Kistler Holding AG and are registered in various countries."
  },
  additionalVersionAndLicenseInformation: {
    "id": "Additional Version and License Information",
    "defaultMessage": "Additional Version and License Information"
  }
});
exports.messages = messages;
//# sourceMappingURL=widgets-i18n.js.map